import { Component, OnInit } from "@angular/core";

import { SiAuthenticationService } from "@strategic-insights/ng-authentication";

declare let $: any;

@Component({
  selector: "si-customer-access",
  templateUrl: "./si-customer-access.component.html",
  styleUrls: ["./si-customer-access.component.scss"],
})
export class SiCustomerAccessComponent implements OnInit {
  customerList: any;
  filteredCustomerList: any;
  selectedCustomer: any;
  isMoreCustomers: any;
  panelHeight: any;
  searchTerm: string = '';

  constructor(private siAuthenticationService: SiAuthenticationService) {}

  /**
   * on inititialization
   */
  ngOnInit() {
    this.customerList = this.siAuthenticationService.getCustomerList();
    this.customerList.sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()));
    this.filteredCustomerList = [...this.customerList];
    this.isMoreCustomers = this.customerList.length > 12 ? true : false;
    this.panelHeight = this.customerList.length > 50 ? "auto" : "100vh";
    this.loadModalProperties();
  }

  /**
   * Submits si customer access component
   */
  submit() {
    this.siAuthenticationService.setActiveCustomer(this.selectedCustomer);
  }

  /**
   * Loads modal properties
   * @returns modal properties
   */
  loadModalProperties(): any {
    $("#siCustomerAccessModal").modal({
      backdrop: "static",
      keyboard: false,
      focus: true,
      show: true,
    });
  }

  /**
   * Sets selected customer
   * @param selectedCustomer:string
   */
  setSelectedCustomer(selectedCustomer: string) {
    this.selectedCustomer = selectedCustomer;
  }

  /**
   * Filters the customer list based on search term
   * @param event Input event from search box
   */
  searchCustomers(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.searchTerm = searchTerm;
    
    if (!searchTerm) {
      this.filteredCustomerList = [...this.customerList];
    } else {
      this.filteredCustomerList = this.customerList.filter(
        (customer: string) => customer.toLowerCase().includes(searchTerm.toLowerCase())
      );

    }
  }
}
